import { c, classy } from '@onfido/castor';
import React, { useEffect, useMemo, useRef, useState, } from 'react';
import { withRef } from '../../utils';
import { OptionListProvider } from './useOptionList';
/**
 * `OptionList` by default uses an `Icon` that requires `Icons` (SVG sprite) to
 * be included in your app.
 *
 * https://github.com/onfido/castor-icons#use-with-plain-code
 *
 * You may also provide any other SVG element via the `icon` prop, but using
 * Castor iconography is recommended.
 */
export const OptionList = withRef(function OptionList({ className, defaultValue, icon, name: initialName, onChange, search, value, ...restProps }, ref) {
    var _a;
    const options = useRef(new Map());
    // initialize with empty array to ensure re-render even with nullish value
    const [currentValue, _setCurrentValue] = useState((_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : []);
    const setCurrentValue = (value) => 
    // default to first option if value is not in options
    _setCurrentValue(options.current.has(value) ? value : options.current.keys().next().value);
    // set value every time it changes and it's not nullish
    useEffect(() => {
        if (value != null)
            setCurrentValue(value);
    }, [value]);
    const name = useMemo(() => initialName || `castor-options-${++id}`, [initialName]);
    return (React.createElement(OptionListProvider, { value: {
            icon,
            name,
            search,
            value: currentValue,
            initialize(option, value) {
                options.current.set(value, option);
            },
            select(option, value) {
                // if there are repeated keys, make the selected one take priority
                options.current.set(value, option);
                setCurrentValue(value);
                onChange === null || onChange === void 0 ? void 0 : onChange({ option, value });
            },
        } },
        React.createElement("div", { ...restProps, ref: ref, role: "listbox", className: classy(c('option-list'), className) })));
});
let id = 0;
//# sourceMappingURL=option-list.js.map